<template>

  <NuxtLink
    :to="post.url"
    class="card card--blog"
    v-for="(post, i) in posts"
    :key="i"
  >
    <div class="card__image">
      <img :src="post.image" alt="" />
      <div class="card__wrapper-overlay">
        <div class="card__button small">
          Read More <i class="fal fa-angle-right"></i>
        </div>
      </div>
    </div>
    <div class="card__wrapper">
      <div class="card__date">{{ post.date }}</div>
      <div class="card__title">
        {{ post.title }}
      </div>
    </div>
  </NuxtLink>
</template>

<script setup>

import { useTranslationStore } from "@/stores/translations";
const translationStore = useTranslationStore();
const translate = translationStore.translate;

const props = defineProps({
  posts: {
    type: Object,
    required: true,
  }
});

</script>

<style lang="scss" scoped>
@import "@/assets/scss/app";
@each $lang in $languages {
  html[lang="#{$lang}"] {
    .card {
      &.card--blog {
        .card__date {
          @include font-size("body-2", $lang);
          @include font-weight("bolder", $lang);
        }
        .card__title {
          @include font-size("body-2", $lang);
        }
      }
    }
  }
}
.card {
  &.card--blog {
    position: relative;
    margin-bottom: 50px;
    background-color: transparent;
    min-height: 364px;
    .card__image {
      overflow: hidden;
      position: relative;
      border-radius: 20px;
      img {
        width: 100%;
        border-radius: 20px;
        height: auto;
        object-fit: cover;
        object-position: center;
        @include transition;
      }
    }

    .card__wrapper-overlay {
      height: 100%;
      width: 100%;
      position: absolute;
      top: 0;
      left: 0;
      border-radius: 20px;
      opacity: 0;
      display: flex;
      justify-content: center;
      align-items: center;
      flex-direction: column;
      @include transition();
      background: linear-gradient(
        0deg,
        rgba($black, 0.64) 0%,
        rgba($black, 0.64) 100%
      );
    }

    .card__button {
      display: flex;
      align-items: end;
      flex-direction: row;
      gap: 10px;
      @include transition();
      transform: translateY(80px);
      color: $white;
      i {
        font-size: px-to-rem(20);
      }
    }

    .card__date {
      margin: 1rem 0 0.5rem 0;
      color: $yellow-ci;
    }
    .card__title {
      color: $black-4;
      display: -webkit-box;
      -webkit-line-clamp: 4;
      -webkit-box-orient: vertical;
      overflow: hidden;
    }

    @include hover {
      .card__image {
        img {
          transform: scale(1.075);
        }
      }
      .card__wrapper-overlay {
        opacity: 1;
      }

      .card__button {
        transform: translateY(0px);
      }
    }
  }
}
</style>